import { add, format, startOfMonth, sub } from 'date-fns';
import { pt } from 'date-fns/locale';
/**
 * Receive a date and return a string in the format DD/MM/YYYY
 * @param date - date to be formatted
 *
 * @returns string in the format DD/MM/YYYY
 */
function dateToDdMmYyyyString(date) {
    var day = date.getDate();
    var month = date.getMonth() + 1; // add 1 to the month index to make it a date (0-11) -> (1-12)
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
}
/**
 * Format date range in  and return a string with a placeholder when date is null
 * @param dateRange - date range to be formatted
 *
 * @returns string representing date range in "DD/MM/YYYY -  DD/MM/YYYY" format
 */
export function formatDateRange(dateRange) {
    var startDate = dateRange.startDate, endDate = dateRange.endDate;
    var startFormattedDate = dateToDdMmYyyyString(startDate);
    var endFormattedDate = endDate
        ? dateToDdMmYyyyString(endDate)
        : startFormattedDate;
    return startFormattedDate + " - " + endFormattedDate;
}
/**
 * Get the first day of the next month of a date
 * @param date - date to be modified
 * @returns
 */
function dateAtStartOfNextMonth(date) {
    return startOfMonth(add(date, { months: 1 }));
}
/**
 * Get an array of all 1st's of each month between the start and end dates in descending order
 *
 * @param minDate - minimum date allowed
 * @param maxDate - maximum date allowed
 * @returns array of dates
 */
function firstDayOfMonths(minDate, maxDate) {
    var months = [];
    var currentDate = minDate;
    while (currentDate <= maxDate) {
        months.push(currentDate);
        currentDate = dateAtStartOfNextMonth(currentDate);
    }
    return months.reverse();
}
/**
 * Build an array with the months options between two dates
 *
 * @param minDate {Date} - minimum date allowed
 * @param maxDate {Date} - maximum date allowed
 * @param locale {Locale} - locale to apply date-fns format, if missing defaults to 'pt'
 * @returns array of months options for dropdown
 */
export function buildMonthsOptions(minDate, maxDate, locale) {
    var ONE_YEAR_AGO = sub(new Date(), { years: 1 });
    var TODAY = new Date();
    // if no selected month default to one year ago
    var startDate = minDate || ONE_YEAR_AGO;
    // if no selected month default to today
    var endDate = maxDate || TODAY;
    return firstDayOfMonths(startDate, endDate).map(function (date) { return ({
        // use portuguese locale as default
        name: format(date, 'MMMM yyyy', { locale: locale || pt }),
        id: date.getTime(),
    }); });
}
